// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-card__subtitle[data-v-dc0c92be]{letter-spacing:.025rem}", ""]);
// Exports
module.exports = exports;
